import { createBrowserRouter } from 'react-router-dom';
import { wrapCreateBrowserRouter } from '@sentry/react';
import { routes } from '@/routes';

// Sentry's data-router wrapper: it hooks into the router so pageload and
// navigation transactions are named by matched route pattern. Pairs with
// reactRouterBrowserTracingIntegration in sentry-init.ts. A no-op when Sentry
// is not initialised (no DSN).
const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter(routes);
